import normalizeArguments from './normalizeArguments.js';
import parsePhoneNumber_ from './parsePhoneNumber_.js';
export default function parsePhoneNumber() {
  var _normalizeArguments = normalizeArguments(arguments),
    text = _normalizeArguments.text,
    options = _normalizeArguments.options,
    metadata = _normalizeArguments.metadata;
  return parsePhoneNumber_(text, options, metadata);
}
//# sourceMappingURL=parsePhoneNumber.js.map


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/es6/parsePhoneNumber.js
// module id = D8z4
// module chunks = 64